/* Consejos antes y después de un tratamiento — versión española.
 * Precauciones generales, sin promesa de resultado y sin sustituir a la
 * consulta médica. */

const conseilsEs = {
    eyebrow: "Preparar y cuidar tu tratamiento",
    h1: "Consejos antes y después de un tratamiento",
    lead: "Un tratamiento bien preparado transcurre mejor y se recupera antes. Estas son las precauciones que repasamos en consulta, reunidas aquí para que puedas releerlas en casa. No sustituyen las indicaciones personalizadas de la médica, que siempre prevalecen.",
    beforeTitle: "Antes de cualquier sesión",
    beforeLead:
        "Estas reglas valen para todos los tratamientos realizados en la clínica, del peeling a la depilación láser:",
    beforeItems: [
        "informa de cualquier embarazo, lactancia o tratamiento en curso, incluidos los complementos alimenticios y las cremas prescritas",
        "informa de un herpes recurrente, de antecedentes de cicatrices en relieve o de una enfermedad autoinmune: algunos gestos requieren preparación o se aplazan",
        "ven sin maquillaje, sin perfume ni autobronceador en la zona que se va a tratar",
        "evita la exposición solar y las cabinas de rayos UVA en las dos semanas previas",
        "avísanos si has recibido una vacuna o un tratamiento estético en otro centro en los últimos quince días",
        "reserva un rato tranquilo después: nada de deporte intenso, ni sauna, ni un acto importante esa misma noche",
    ],
    laserTitle: "Antes de una sesión de depilación láser o electrólisis",
    laserItems: [
        "rasura la zona la víspera o esa mañana: el vello debe estar presente bajo la piel, pero no en la superficie",
        "no te depiles con cera, pinzas ni hilo durante las cuatro semanas previas, el láser necesita la raíz",
        "nada de autobronceador durante dos semanas, ni bronceado reciente en la zona",
        "suspende los exfoliantes y los activos exfoliantes dos o tres días antes",
        "avísanos si tomas algún medicamento fotosensibilizante; algunos antibióticos lo son",
    ],
    peelTitle: "Antes de un peeling, un microneedling o una mesoterapia",
    peelItems: [
        "suspende retinoides, ácidos y exfoliantes de cinco a siete días antes, salvo indicación contraria de la médica",
        "informa de cualquier tratamiento con isotretinoína, actual o reciente",
        "programa la sesión lejos de un acto importante: es posible que haya enrojecimiento y descamación durante unos días",
        "hidrata bien la piel los días previos, una piel flexible reacciona mejor",
        "si tienes herpes labial recurrente, puede prescribirse un tratamiento preventivo antes de un tratamiento facial",
    ],
    injTitle: "Antes de unas inyecciones",
    injItems: [
        "evita la aspirina, el ibuprofeno y los complementos que fluidifican la sangre en los días previos, salvo que te los hayan prescrito: nunca interrumpas un tratamiento por tu cuenta",
        "evita el alcohol la víspera, aumenta los hematomas",
        "come con normalidad antes de venir",
        "no programes inyecciones la semana de una boda, un viaje o una foto importante",
        "informa de cualquier tratamiento dental previsto o reciente, que puede justificar aplazar la sesión",
    ],
    afterTitle: "Después de la sesión",
    afterParagraphs: [
        "Casi todos los tratamientos tienen consecuencias pasajeras: enrojecimiento, calor, hinchazón leve, pequeños hematomas tras las inyecciones, descamación tras un peeling. Son habituales, transitorias y se te explican antes de la sesión. Lo que cuenta después es dejar la piel tranquila.",
        "Durante cuarenta y ocho horas se evitan el calor y el roce. No se rasca, no se exfolia y no se arrancan las pieles: así se evitan las marcas.",
    ],
    afterItems: [
        "nada de deporte intenso, hammam, sauna, piscina ni baño caliente durante 48 horas",
        "limpieza suave, hidratante sencilla y ningún producto nuevo en los días siguientes",
        "nada de maquillaje en la zona durante 24 horas tras un microneedling, una mesoterapia o unas inyecciones",
        "protección solar alta todos los días, incluso con el cielo nublado",
        "nada de masajes ni presión en la zona inyectada, salvo indicación contraria de la médica",
        "bebe con normalidad y duerme con la cabeza algo elevada la primera noche tras unas inyecciones faciales",
    ],
    soleilTitle: "El sol, el verdadero tema",
    soleilParagraphs: [
        "La fotoprotección no es un detalle de confort: es lo que protege el beneficio de un tratamiento. Sobre una piel debilitada por un peeling, un láser o un microneedling, incluso una exposición breve puede dejar una mancha duradera, sobre todo en pieles pigmentadas y en caso de melasma.",
        "Se aplica un índice alto por la mañana y se renueva durante el día si hay exposición, todo el año e incluso detrás de un cristal. Sombrero, gafas y sombra completan muy bien la crema en las semanas posteriores a un tratamiento.",
    ],
    alerteTitle: "Cuándo volver a contactar",
    alerteLead:
        "La mayoría de las molestias se resuelven solas. Contacta con la clínica, o con un médico si no logras contactar con la clínica, si observas:",
    alerteItems: [
        "un dolor que aumenta en lugar de disminuir después de 48 horas",
        "un enrojecimiento que se extiende, una zona caliente o fiebre",
        "una ampolla, una costra gruesa o una herida que no cierra",
        "una zona que palidece, se vuelve violácea o pierde sensibilidad tras una inyección",
        "cualquier signo que te preocupe y del que no hubiéramos hablado",
    ],
    alerteFin:
        "En caso de urgencia médica, no esperes respuesta: llama al 15 o al 112, o acude al servicio de urgencias más cercano. La clínica no atiende urgencias.",
    faqTitle: "Preguntas frecuentes sobre el posoperatorio",
    faq: [
        [
            "¿Puedo maquillarme después de una sesión?",
            "Tras un peeling superficial, por lo general sí desde el día siguiente. Tras un microneedling, una mesoterapia o unas inyecciones conviene esperar veinticuatro horas: la piel presenta microaberturas y el maquillaje aumenta el riesgo de irritación. La indicación exacta se te da al terminar la sesión.",
        ],
        [
            "¿Cuánto duran los hematomas tras una inyección?",
            "Cuando aparece un hematoma, suele atenuarse en cinco a diez días, a veces algo más en los labios y las ojeras. Se cubre muy bien con un corrector una vez cerrada la piel.",
        ],
        [
            "¿Puedo hacer deporte el mismo día?",
            "Es mejor evitarlo durante cuarenta y ocho horas. El esfuerzo aumenta el calor, la sudoración y el flujo sanguíneo, tres factores que agravan el enrojecimiento, la hinchazón y el riesgo de hematoma.",
        ],
        [
            "¿Qué hago si mi piel se descama tras un peeling?",
            "Es el efecto buscado. Hay que dejar que ocurra: limpieza suave, hidratación, protección solar y, sobre todo, no arrancar las pieles, ni siquiera las que cuelgan. Arrancarlas es la mejor forma de dejar una mancha.",
        ],
        [
            "¿Estos consejos sustituyen una consulta?",
            "No. Dan el marco general de los tratamientos realizados en la clínica. Tus indicaciones dependen de tu piel, de tus tratamientos y del tratamiento realizado: solo prevalecen las que se te dan en consulta.",
        ],
    ],
};

export default conseilsEs;
